import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Params = Api.Core.ClaimJobDocument.SavePublic.IParams;
type Request = Api.Core.ClaimJobDocument.SavePublic.IRequest;
type Response = Api.Core.ClaimJobDocument.SavePublic.IResponse;
type Headers = Api.Core.ClaimJobDocument.SavePublic.IHeaders;
const url = '/api/Public/UploadClaimJobDocument/:claimJobId';
export default async function claimJobDocumentSavePublicApi({
  params,
  body,
}: {
  params: Params;
  body: Request;
}): Promise<Api.Res<Response>> {
  return await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.post,
    url: createPathFromRoute(url, params),
    body,
    headers: getDefaultHeaders(),
  });
}
